import { AnyAction } from "redux";
import { ITransactionStore } from "./types";
import ActionTypes from "../../../constants/ActionTypes";

const initialState: ITransactionStore = {
  data: {
    flow: "",
    onlyPosition: false,
    details: {
      order: {
        status: "",
        secret: "",
        referenceId: "",
        finishedAt: "",
        shoppingDate: "",
        shoppingTime: "",
      },
      payment: {
        cardNumber: "",
        cardType: "",
      },
      transaction: null,
    },
    basket: {
      items: [
        {
          type: "",
          items: [],
          subtotal: {
            price: 0,
            checkout: 0,
            installments: 0
          },
        },
      ],
      applicableBenefits: []
    },
  },
};

const storesMapReducer = (
  state = initialState,
  action: AnyAction
): ITransactionStore => {
  switch (action.type) {
  case ActionTypes.TRANSACTION.SET_TRANSACTION:
    return {
      ...state,
      data: action.payload,
    };
  case ActionTypes.TRANSACTION.SET_TRANSACTION_STATUS:
    return {
      ...state,
      data: {
        ...state.data,
        details: {
          ...state.data.details,
          order: {
            status: action.payload,
            secret: state.data.details.order.secret,
            referenceId: state.data.details.order.referenceId,
            finishedAt: state.data.details.order.finishedAt,
            shoppingDate: state.data.details.order.shoppingDate,
            shoppingTime: state.data.details.order.shoppingTime,
          },
        },
      },
    };
  }

  return state;
};

export default storesMapReducer;
